<template>
  <div>
    <div v-if="store.token">
      <button
        @click="logout"
        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #fff"
      >
        Logout
      </button>
    </div>
    <div v-else-if="devMode">
      <button
        @click="login"
        :style="buttonStyle"
        data-test="login"
      >
        Login
      </button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import getContrastYIQ from '@/helpers/getContrastYIQ';
import { useAuthStore } from '@/stores/AuthStore.js';

const store = useAuthStore();

const backgroundColor = ref('#ffffff');

const devMode = ref(process.env.NODE_ENV === 'development');

const buttonStyle = computed(() => {
  const textColor = getContrastYIQ(backgroundColor.value);
  return {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: backgroundColor.value,
    color: textColor,
    padding: '20px',
  };
});

onMounted(() => {
  // If the user is on the logout page, log them out immediately -- this will also result in a redirect
  if (window.location.pathname === '/logout') {
    store.logout();
  }
});

// Call the login action to log the user in
const login = () => {
  store.login();
};

const logout = () => {
  store.logout();
};
</script>
